import { gql } from "@apollo/client";

export default gql`
  fragment ThumbnailFragment on ImageAttachment {
    id
    originalUrl
    fileName
    mimeType
    resizableUrl
    width
    height
  }
`;
